import axios from 'axios';

// Action Types
export const FETCH_APP_SETTINGS_REQUEST = 'FETCH_APP_SETTINGS_REQUEST';
export const FETCH_APP_SETTINGS_SUCCESS = 'FETCH_APP_SETTINGS_SUCCESS';
export const FETCH_APP_SETTINGS_FAILURE = 'FETCH_APP_SETTINGS_FAILURE';

export const UPDATE_APP_SETTINGS_REQUEST = 'UPDATE_APP_SETTINGS_REQUEST';
export const UPDATE_APP_SETTINGS_SUCCESS = 'UPDATE_APP_SETTINGS_SUCCESS';
export const UPDATE_APP_SETTINGS_FAILURE = 'UPDATE_APP_SETTINGS_FAILURE';

export const CLEAR_MESSAGES = 'CLEAR_MESSAGES';

// Action Creators
export const fetchAppSettingsRequest = () => ({
  type: FETCH_APP_SETTINGS_REQUEST
});

export const fetchAppSettingsSuccess = (data) => ({
  type: FETCH_APP_SETTINGS_SUCCESS,
  payload: data
});

export const fetchAppSettingsFailure = (error) => ({
  type: FETCH_APP_SETTINGS_FAILURE,
  payload: error
});

export const updateAppSettingsRequest = () => ({
  type: UPDATE_APP_SETTINGS_REQUEST
});

export const updateAppSettingsSuccess = (device) => ({
  type: UPDATE_APP_SETTINGS_SUCCESS,
  payload: device
});

export const updateAppSettingsFailure = (error) => ({
  type: UPDATE_APP_SETTINGS_FAILURE,
  payload: error
});

export const clearMessages = () => ({
  type: CLEAR_MESSAGES
});

// Thunk Actions
export const fetchAppSettings = () => {
  return async (dispatch) => {
    dispatch(fetchAppSettingsRequest());

    try {
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/get/app/version/v1`);

      if (response.data.success) {
        // Process the data to separate Android and iOS settings
        const allSettings = response.data.data;

        // Find the latest settings for each platform
        const androidSettings = allSettings.find(setting => setting.device === 'android') || {
          device: 'android',
          version: '',
          title: '',
          message: '',
          forceUpdate: false
        };

        const iosSettings = allSettings.find(setting => setting.device === 'ios') || {
          device: 'ios',
          version: '',
          title: '',
          message: '',
          forceUpdate: false
        };

        dispatch(fetchAppSettingsSuccess({
          android: androidSettings,
          ios: iosSettings
        }));
      } else {
        dispatch(fetchAppSettingsSuccess({
          android: {
            device: 'android',
            version: '',
            title: '',
            message: '',
            forceUpdate: false
          },
          ios: {
            device: 'ios',
            version: '',
            title: '',
            message: '',
            forceUpdate: false
          }
        }));
      }
    } catch (error) {
      dispatch(fetchAppSettingsFailure(error.response?.data?.message || 'Failed to fetch app settings'));
    }
  };
};

export const updateAppSettings = (device, settings) => {
  return async (dispatch) => {
    dispatch(updateAppSettingsRequest());
    try {
      // Add authorization header
      const authToken = localStorage.getItem('Authorization');

      const response = await axios.put(`${process.env.REACT_APP_BASE_URL}/change/app/settings/v1`, {
        device,
        ...settings
      }, { headers: { Authorization: authToken } });

      if (response.data.success) {
        dispatch(updateAppSettingsSuccess(device));
      } else {
        dispatch(updateAppSettingsFailure(response.data.message || 'Failed to update settings'));
      }
    } catch (error) {
      dispatch(updateAppSettingsFailure(error.response?.data?.message || 'Failed to update settings'));
    }
  };
};

// Initial State
const initialState = {
  android: {
    device: 'android',
    version: '',
    title: '',
    message: '',
    forceUpdate: false
  },
  ios: {
    device: 'ios',
    version: '',
    title: '',
    message: '',
    forceUpdate: false
  },
  loading: false,
  error: null,
  success: null
};

// Reducer
const appSettingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_APP_SETTINGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case FETCH_APP_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        android: action.payload.android,
        ios: action.payload.ios
      };

    case FETCH_APP_SETTINGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case UPDATE_APP_SETTINGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: null
      };

    case UPDATE_APP_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        success: `${action.payload.toUpperCase()} settings updated successfully`
      };

    case UPDATE_APP_SETTINGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case CLEAR_MESSAGES:
      return {
        ...state,
        error: null,
        success: null
      };

    default:
      return state;
  }
};

export default appSettingsReducer; 